import { createContext, useContext, useEffect, useState } from "react";
import { getMyRights } from "../api/userApi";

export const UserContext = createContext(null);

export function UserProvider({ children }) {
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log('[Auth] App mount — Token exists:', !!localStorage.getItem("Token"), 'UserId:', localStorage.getItem("UserId"), 'RefreshToken exists:', !!localStorage.getItem("RefreshToken"));
        // Always coerce to Number — every other place in the app (login
        // response, API data, hierarchy filter, downline lookup) treats
        // userId as a numeric id. localStorage stringifies it, so without
        // this coercion `===` comparisons like `u.uplineId === myId` fail
        // (1 === "1" is false) and downlines disappear from any page that
        // does that comparison after a page reload.
        const userIdRaw = localStorage.getItem("UserId");
        const userId = userIdRaw != null && userIdRaw !== '' ? Number(userIdRaw) : null;
        const username = localStorage.getItem("Username");
        const firstName = localStorage.getItem("FirstName");
        const lastName = localStorage.getItem("LastName");
        const roles = JSON.parse(localStorage.getItem("Roles")) || [];
        const roleRights = JSON.parse(localStorage.getItem("RoleRights")) || [];
        const groupName = localStorage.getItem("GroupName");
        const profilePhotoUrl = localStorage.getItem("ProfilePhotoUrl");
        const mustAcceptAgreement = localStorage.getItem("MustAcceptAgreement") === "true";
        const applicationStatus = localStorage.getItem("ApplicationStatus") || "Active";
        const accessBlocked = localStorage.getItem("AccessBlocked") === "true";
        // Default MISSING to true (absent => not gated) so existing logged-in
        // sessions and admins (whose login response predates this flag, or
        // who are exempt) aren't accidentally locked out of create-sales.
        const canCreateSale = localStorage.getItem("CanCreateSale") !== "false";
        /* What the agent still has to put on their profile. Empty = nothing outstanding,
           which is also the safe default for a session that predates the flag: an absent
           value must never invent a block. (user 2026-10-23) */
        let profileMissing = [];
        try { profileMissing = JSON.parse(localStorage.getItem("ProfileMissing") || "[]"); }
        catch { profileMissing = []; }
        if (!Array.isArray(profileMissing)) profileMissing = [];

        if (userId) {
            setUser({ userId, username, firstName, lastName, roles, roleRights, groupName, profilePhotoUrl, mustAcceptAgreement, applicationStatus, accessBlocked, canCreateSale, profileMissing });
            // Rights were read once at login and never again, so a permission changed in
            // the matrix stayed invisible until the person logged out and back in - which
            // is how a right every Sales Agent held still hid RSC from all of them. Ask
            // the server what they are NOW, and correct the cache. Render does not wait
            // on it; the menu and guards re-evaluate when it lands. (user 2026-09-27)
            getMyRights()
                .then(res => {
                    const d = res?.data;
                    if (!d || !Array.isArray(d.roleRights)) return;
                    try {
                        localStorage.setItem("Roles", JSON.stringify(d.roles || []));
                        localStorage.setItem("RoleRights", JSON.stringify(d.roleRights));
                        localStorage.setItem("CanCreateSale", String(d.canCreateSale === true));
                        localStorage.setItem("ProfileMissing", JSON.stringify(d.profileMissing || []));
                    } catch { /* private mode */ }
                    setUser(prev => (prev ? {
                        ...prev,
                        roles: d.roles || prev.roles,
                        roleRights: d.roleRights,
                        canCreateSale: d.canCreateSale === true,
                        profileMissing: Array.isArray(d.profileMissing) ? d.profileMissing : [],
                        // Account-wide, so the banner obeys a dismissal made on any device.
                        joinGroupsDismissed: d.joinGroupsDismissed === true,
                    } : prev));
                })
                .catch(() => { /* offline or refused - keep what we have */ });
        } else {
            setUser(null);
        }
        setLoading(false);
    }, []);

    if (loading) {
        return (
            <div style={{ textAlign: "center", marginTop: "40px" }}>
                <div className="spinner"></div>
                <span>Loading...</span>
            </div>
        );
    }

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}